<template>
  <FiltersChip
    :text="filter.text"
    :value="localValue || ''"
    @clear="clear"
  >
    <template #form="{ hide }">
      <v-form
        v-model="formValid"
        @submit.prevent="() => submit(hide)"
      >
        <v-text-field
          v-model="localValue"
          :label="`${filter.text} value`"
          :rules="[(v) => !!v || 'Required']"
          data-testid="text-input"
        />
        <v-checkbox
          v-model="exact"
          label="Exact match"
          class="mt-0"
        />
        <v-checkbox
          v-model="caseSensitive"
          label="Case sensitive"
          class="mt-0"
        />
        <v-btn
          class="mt-2"
          color="primary"
          type="submit"
          small
          :disabled="!formValid"
        >
          <v-icon
            left
            small
          >
            mdi-refresh
          </v-icon>
          Apply
        </v-btn>
        <v-btn
          class="ml-2 mt-2"
          small
          @click="hide || null"
        >
          <v-icon
            left
            small
          >
            mdi-cancel
          </v-icon>
          Cancel
        </v-btn>
      </v-form>
    </template>
  </FiltersChip>
</template>

<script>
import FiltersChip from './FiltersChip.vue';

export default {
  name: 'CaseActivityFiltersText',
  components: {
    FiltersChip,
  },
  props: {
    filter: {
      type: Object,
      required: true,
    },
    values: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      localValue: '',
      exact: false,
      caseSensitive: false,
      formValid: false,
      prevQueryName: '',
    };
  },
  computed: {
    lookupExpr() {
      if (this.exact && this.caseSensitive) {
        return '';
      } if (this.caseSensitive) {
        return 'contains';
      } if (this.exact) {
        return 'iexact';
      }
      return 'icontains';
    },
    queryName() {
      return this.lookupExpr ? `${this.filter.name}__${this.lookupExpr}` : this.filter.name;
    },
  },
  watch: {
    values(val) {
      if (!val[this.queryName]) {
        this.localValue = '';
      }
    },
  },
  created() {
    if (this.values[`${this.filter.name}`]) {
      this.exact = true;
      this.caseSensitive = true;
    } else if (this.values[`${this.filter.name}__contains`]) {
      this.caseSensitive = true;
    } else if (this.values[`${this.filter.name}__iexact`]) {
      this.exact = true;
    }
    this.localValue = this.values[this.queryName];
  },
  methods: {
    submit(hideCallback) {
      const newValues = { [this.queryName]: this.localValue };
      if (this.prevQueryName && this.prevQueryName !== this.queryName) {
        newValues[this.prevQueryName] = undefined;
      }
      this.$emit('apply', newValues);
      this.prevQueryName = this.queryName;
      hideCallback();
    },
    clear() {
      this.localValue = '';
      this.$emit('apply', { [this.queryName]: undefined });
    },
  },
};
</script>
